import {  FC, ReactNode } from 'react';
import './App.css';

interface Props {
    children?: ReactNode
}

export const Header: FC<Props> = ({  children }) => (
    <div className='headerPanel'>
        {children}
    </div>
) 